<template> 
  <div>
    <!--  onselectstart="return false;"禁止复制功能 -->
    <app-header></app-header>
    <div :class="isLogin?'mt-70':''">
      <v-container grid-list-xl pt-0>
        <v-layout row wrap>
          <v-flex xs12 md12 lg12 sm12 class="col-height-auto">
            <v-card
              class="mb-3"
              v-for="market in marketList"
              v-if="market.name==marketsName"
              :key="market.marketId"
            >
              <v-img height="200" :src="market.image">
                <v-container fill-height fluid pa-2>
                  <v-layout fill-height>
                    <v-flex xs12>
                      <span class="font-20 fw-700 white--text ml-3" v-text="marketsName"></span>
                    </v-flex>
                  </v-layout>
                </v-container>
              </v-img>
            </v-card>
            <v-layout row wrap>
            <v-flex xs12 md7 lg8>
              <div>
               <v-card class="mb-4" v-for="(post,index) in postList" :key="index">
                <div class="media-listing">
                  <ul class="list-unstyled">
                    <li class="media">
                      <div v-for="(user, index) in userDetailList" v-if="post.postingUserId == user.userId" :key="index" class="ml-2 pt-3 mr-2">
                        <!-- <span @click="goUserData(user.userName)" class="pointer user-avatar">
                        <img class="img-responsive rounded-circle posting-img" :src="user.image">
                      </span> -->
                        <div class="mb-3">
                          <v-avatar color="primary" class="pointer" size="34" @click="goUserData(user.userName)">
                            <img v-show="user.image != null" :src="user.image" :alt="user.userName" />
                            <span v-show="user.image == null" class="headline white--text">
                              {{
                                user.userName
                                  .trim()
                                  .substring(0, 1)
                                  .toLocaleUpperCase()
                              }}
                            </span>
                          </v-avatar>
                          <span @click="goUserData(user.userName)" class="pl-2 pointer hover-color font-16 fw-700">
                            {{ user.nickName }}
                            <span>({{ user.reputationScore }})</span>
                          </span>
                          <span class="px-2 fw-500 font-14">
                            <v-icon size="16">schedule</v-icon>
                            {{ dateFormat(post.postingTime) }}
                          </span>
                        </div>

                        <div class="row">
                          <div v-for="(user, index) in userDetailList" v-if="post.postingUserId == user.userId" :key="index" class="px-0">
                            <span
                              v-if="post.postingImg != ''"
                              v-html="post.postingImg"
                              @click="findsel(post)"
                              class="rounded-circle mr-4 img-responsive posts-image pointer"
                            ></span>
                          </div>
                          <div class="media-body">
                            <h2 class="fw-700 pointer break-word" @click="findsel(post)">{{ post.postingTitle }}</h2>
                            <h4 class="mb-3 py-2" v-html="post.postingContent" @click="findsel(post)"></h4>
                            <div class="mt-1 justify-space-between">
                              <div class="social">
                                <span class="pointer">
                                  <v-icon small :title="$t('posting.bonus')">fas fa-dollar-sign</v-icon>
                                  <span class="font-1x fw-400 ml-1">{{ post.bonus.toFixed(2) }}</span>
                                </span>
                                <span v-if="post.postingStatus == 0" class="ml-2">
                                  <v-icon @click="changesup(post)" small color="primary" :title="$t('posting.upvote')">thumb_up</v-icon>
                                  <span class="font-14 fw-400 ml-1">{{ post.postingGoodnums }}</span>
                                  <v-icon @click="changesdown(post)" small class="ml-2" :title="$t('postingsel.tread')">thumb_down</v-icon>
                                  <span class="font-14 fw-400 ml-1">{{ post.postingStepnums }}</span>
                                </span>
                                <span v-if="post.postingStatus == 1" class="ml-2">
                                  <v-icon @click="changesup(post)" small :title="$t('posting.upvote')">thumb_up</v-icon>
                                  <span class="font-14 fw-400 ml-1">{{ post.postingGoodnums }}</span>
                                  <v-icon @click="changesdown(post)" class="ml-2" small color="primary" :title="$t('postingsel.tread')">thumb_down</v-icon>
                                  <span class="font-14 fw-400 ml-1">{{ post.postingStepnums }}</span>
                                </span>
                                <span v-if="post.postingStatus == -1" class="ml-2">
                                  <v-icon small @click="changesup(post)" :title="$t('posting.upvote')">thumb_up</v-icon>
                                  <span class="font-14 fw-400 ml-1">{{ post.postingGoodnums }}</span>
                                  <v-icon @click="changesdown(post)" class="ml-2" small :title="$t('postingsel.tread')">thumb_down</v-icon>
                                  <span class="font-14 fw-400 ml-1">{{ post.postingStepnums }}</span>
                                </span>
                                <span class="ml-2">
                                  <v-icon @click="findsel(post)" small :title="$t('posting.comment')">fa fa-comment</v-icon>
                                  <span class="font-14 fw-400 ml-1">{{ post.postingCountComments }}</span>
                                </span>
                                <span class="ml-2" v-for="(user, index) in userDetailList" v-if="post.postingUserId == user.userId">
                                  <v-icon @click="modalzf(post, user)" small :title="$t('posting.retweet')">fa fa-share</v-icon>
                                  <span class="font-14 fw-400 ml-1">{{ post.postingCountForword }}</span>
                                </span>
                                <span class="ml-2">
                                  <v-icon v-if="post.postingCollection == 0" @click="collectionPosting(post)" small color="primary" :title="$t('posting.save')">
                                    fa fa-star
                                  </v-icon>
                                </span>
                                <span><v-icon v-if="post.postingCollection != 0" @click="collectionPosting(post)" small :title="$t('posting.save')">fa fa-star</v-icon></span>
                              </div>
                            </div>
                          </div>
                        </div>
                        <div class="mt-3">
                          <span class="flex-middle" v-for="(postcomments, index) in commentList" v-if="post.postingId == postcomments.commentsPostingId" :key="index">
                            
                            <!-- - - 评论人头像 - - -->
                            <span v-for="(userpopular, index) in commentUserDetailList" v-if="postcomments.commentsUserId == userpopular.userId" :key="index">
                              <!-- <v-avatar size="32">
                          <img class="img-responsive rounded-circle comment-img" v-bind:src="userpopular.image">
                        </v-avatar> -->
                              <v-avatar color="primary" class="pointer" size="32" @click="goUserData(userpopular.userName)">
                                <img v-show="userpopular.image != null" :src="userpopular.image" :alt="userpopular.userName" />
                                <span v-show="userpopular.image == null" class="headline white--text">
                                  {{
                                    userpopular.userName
                                      .trim()
                                      .substring(0, 1)
                                      .toLocaleUpperCase()
                                  }}
                                </span>
                              </v-avatar>
                            </span>
                            <!-- - - 评论文本- - - -->
                            <span class="font-14 fw-500 ml-2">
                              <span v-if="post.postingContent.length > 20">{{ postcomments.commentsContext }}</span>
                              <span v-else>{{ postcomments.commentsContext }}……</span>
                            </span>
                          </span>
                        </div>
                      </div>
                    </li>
                 </ul>
                </div>
              </v-card>
                 <!--infinite-loading这个组件要放在列表的底部，滚动的盒子里面！-->
                  <infinite-loading :identifier="timestamp" @infinite="getPostList" class="mb-3">
                    <div slot="spinner">
                      <v-progress-circular indeterminate color="primary"></v-progress-circular>
                    </div>
                    <div slot="no-more">{{$t("posting.noMore")}}</div>
                    <div slot="no-results">{{$t("posting.noResults")}}</div>
                  </infinite-loading>
              </div>
              <!--转发模态窗-->
              <v-dialog v-model="forwardModal" persistent max-width="600px">
                <v-card>
                  <v-card-title>
                    <span class="font-30 fw-500">{{ $t('posting.retweet') }}</span>
                  </v-card-title>
                  <v-list two-line>
                    <v-list-tile>
                      <v-list-tile-avatar>
                        <!-- <span @click="goUserData(postUserName)" class="pointer user-avatar">
                            <img class="img-responsive rounded-circle posting-img" :src="postUserImage">
                          </span> -->
                        <v-avatar color="primary" class="pointer" size="32" @click="goUserData(postUserName)">
                          <img v-show="postUserImage != null" :src="postUserImage" :alt="postUserName" />
                          <span v-show="postUserImage == null" class="headline white--text">
                            {{
                              postUserName
                                .trim()
                                .substring(0, 1)
                                .toLocaleUpperCase()
                            }}
                          </span>
                        </v-avatar>
                      </v-list-tile-avatar>
                      <v-list-tile-content>
                        <v-list-tile-title>
                          <span @click="goUserData(postUserName)" class="pointer font-18 fw-700">{{ postNickName }}</span>
                          <span class="px-2 font-16 fw-700">
                            {{ $t('common.at') }}
                            <v-icon size="18">schedule</v-icon>
                            {{ dateFormat(postDate) }}
                          </span>
                        </v-list-tile-title>
                        <v-list-tile-sub-title>
                          <span class="font-14 fw-700">{{ postTitle }}</span>
                        </v-list-tile-sub-title>
                      </v-list-tile-content>
                    </v-list-tile>
                  </v-list>
                  <v-card-text>
                    <v-container grid-list-md>
                      <v-layout wrap>
                        <v-flex xs12 sm6 md12>
                          <v-form ref="formValidatezf"><v-textarea solo name="input-7-4" v-model="formValidatezf.postingForwardContext"></v-textarea></v-form>
                        </v-flex>
                      </v-layout>
                    </v-container>
                  </v-card-text>
                  <v-card-actions>
                    <v-spacer></v-spacer>
                    <v-btn class="primary" flat @click="forwardModal = false">Close</v-btn>
                    <v-btn class="primary" flat @click="postingforward">Save</v-btn>
                  </v-card-actions>
                </v-card>
              </v-dialog>
            </v-flex>
              <!-- <div class="text-xs-left mb-3" v-show="tagName != null">
                      <v-chip color="aquamarine" text-color="white">
                          {{ tagName }}
                          <v-btn icon small color="aquamarine" class="white--text" @click="tagName = null">
                              <v-icon>close</v-icon>
                          </v-btn>
                      </v-chip>
                  </div>
                  <template class="app-card">
                      <div style="margin:0 20px;">
                          <label style="font-size: 16px;border-bottom: 1px solid  #EEEEEE;display:block;text-align: center;height: 30px;line-height: 15px;font-weight: bold;" class="mt-3">
                              {{$t("left.tags")}}
                          </label>
                          <div class="mt-3 mb-3">
                              <Tag v-for="(tag, index) in tagList" :key="tag.tagId" type="border" color="#41B8BC" class="body-2">
                                  <span @click="getPostsByTagName(tag.tagName)">{{tag.tagName}}</span>
                              </Tag>
                          </div>
                          <div v-show="isShowAll" class="postmiddle-right mt-3">
                              <ul style="list-style: none;font-size: .8rem; margin-bottom: 20px; text-align: center;">
                                  <li>
                                      <span @click="showAllTag" class="body-2 ml-1 pointer">
                                          <span >{{$t("left.showall")}}</span>
                                          <v-icon medium style="vertical-align:middle;">keyboard_arrow_down</v-icon>
                                      </span>
                                  </li>
                              </ul>
                          </div>
                          <div v-show="isShowUpward" class="postmiddle-right">
                              <ul style="list-style: none;font-size: .8rem;margin-bottom: 20px;text-align: center;">
                                  <li>
                                      <span @click="upwardTag" class="body-2 ml-1 pointer">
                                          <span>{{$t("left.Upward")}}</span>
                                          <v-icon medium style="vertical-align:middle;">keyboard_arrow_up</v-icon>
                                      </span>
                                  </li>
                              </ul>
                          </div>
                      </div>
              </template>-->
              <v-flex xs12 md5 lg4>
                <app-right></app-right>
              </v-flex>
            </v-layout>
          </v-flex>
        </v-layout>
      </v-container>
    </div>
  </div>
</template>
<style>
</style>
<script>
import Vue from "vue";
import config from "../../config.js";
import InfiniteLoading from "vue-infinite-loading";
import { mapGetters } from "vuex";
export default {
  data() {
    return {
      marketsName: this.$route.params.marketsName, //市场名称
      tabs: null,
      marketCode: null, // 市场
      timestamp: +new Date(), // 时间戳
      tagName: null, // 标签名
      isShowSelectTag: true,
      isLoadingList: false, // 是否正在加载集合
      loadTimes: 0, // 加载次数
      pageNo: 0, // 页码
      pageSize: 10, // 每次查询几条数据
      postList: [], // 帖子集合
      userDetailList: [], // 发帖用户集合
      commentList: [], // 帖子评论集合
      commentUserDetailList: [], // 评论用户集合
      postingIds: [], // 需要查询操作的帖子ID集合
      forwardModal: false, // 转发按钮
      postUserImage: "", //作者的头像
      postTitle: "", //帖子标题
      postDate: "", //发帖日期
      postNickName: "", //作者昵称
      postUserName: "", //作者用户名
      formValidatezf: {
        // 转发帖子的对象
        postingUserforwardId: this.$store.state.user.id,
        postingId: "",
        postingForwardContext: ""
      },
      formCollection: {
        // 收藏帖子表单
        userId: "",
        postingId: ""
      },
      marketList: [], // 市场集合
      isShowAll: false, // 是否显示显示全部
      isShowUpward: false, // 是否显示向上收起
      tagList: [], // 显示的标签集合
      allTagList: [] // 所有标签集合
    };
  },
  created() {
    /* this.getMarkets(); */
  },
  computed: {
    ...mapGetters(["user"]),
    isLogin() {
      if (
        this.$store.state.user.token != null &&
        this.$store.state.user.token != ""
      ) {
        return true;
      } else {
        return false;
      }
    }
  },
  mounted() {
    //加载标签
    this.getAllTagByHot();
    this.getMarkets();
  },
  watch: {
    $route() {
      if (this.$route.params.marketsName) {
        this.marketsName = this.$route.params.marketsName;
      }
    },
    marketsName() {
      if (this.marketsName != null) {
        this.refreshPosts();
      }
    },
    tagName() {
      this.refreshPosts();
    }
  },
  components: {
    InfiniteLoading
  },
  methods: {
    // 按市场排序分页查询帖子
    getPostList($state) {
      this.marketCode = this.marketsName.replace(" ", "").toLowerCase();
      if (this.isLoadingList) {
        return;
      }
      if (!this.marketCode) {
        return;
      }
      this.isLoadingList = true;
      let url =
        config.baseUrl +
        "posting/open/getPosts/market/" +
        this.pageNo +
        "/" +
        this.pageSize +
        "/" +
        this.marketCode;
      if (this.tagName) {
        url =
          config.baseUrl +
          "posting/open/getPosts/market/tag/" +
          this.pageNo +
          "/" +
          this.pageSize +
          "/" +
          this.marketCode +
          "/" +
          this.tagName;
      }
      this.$http.get(url).then(response => {
        let data = response.data;
        this.loadTimes += 1;
        this.isLoadingList = false;
        if (data.resCode == 0) {
          let result = data.result;
          this.pageNo += 1;
          this.postList = [...this.postList, ...result.postList];
          this.commentList = [...this.commentList, ...result.commentList];
          if (localStorage.getItem("token")) {
            // 加载操作信息
            this.getUserActions(result.postList);
          }
          let udList = result.userDetailList;
          let cudList = result.commentUserDetailList;
          //如果新查询出来的UserDetail与集合中的重复，就将其删除
          for (let i = 0; i < this.userDetailList.length; i++) {
            for (let j = 0; j < udList.length; j++) {
              if (this.userDetailList[i].userId == udList[j].userId) {
                //删除数组中的这个对象
                udList.splice(j, 1);
              }
            }
          }
          for (let i = 0; i < this.commentUserDetailList.length; i++) {
            for (let j = 0; j < cudList.length; j++) {
              if (this.commentUserDetailList[i].userId == cudList[j].userId) {
                //删除数组中的这个对象
                cudList.splice(j, 1);
              }
            }
          }
          this.userDetailList = [...this.userDetailList, ...udList];
          this.commentUserDetailList = [
            ...this.commentUserDetailList,
            ...cudList
          ];
          $state.loaded();
        } else {
          $state.complete();
        }
        if (this.loadTimes == 1) {
          this.timestamp = +new Date();
        }
      });
    },
    // 重新加载帖子
    refreshPosts() {
      this.postList = [];
      this.userDetailList = [];
      this.commentList = [];
      this.commentUserDetailList = [];
      this.pageNo = 0;
      this.loadTimes = 0;
      this.timestamp = +new Date();
    },
    // 获得市场分类的集合
    getMarkets() {
      this.$http
        .get(config.baseUrl + "market/open/getMarkets")
        .then(response => {
          let data = response.data;
          if (data.resCode == 0) {
            this.marketList = data.result;
          } else {
            this.marketList = [];
          }
        });
    },
    // 用户登录后根据帖子集合加载操作信息
    getUserActions(postList) {
      if (!localStorage.getItem("token")) {
        return;
      }
      for (let i = 0; i < postList.length; i++) {
        this.postingIds[i] = postList[i].postingId;
      }
      //查询用户是否对帖子点赞点踩
      let url =
        config.baseUrl +
        "posting/UserEvalutiongood/" +
        this.$store.state.user.id;
      this.$http.post(url, this.postingIds).then(successData => {
        let voteList = successData.data.result;
        for (let i = 0; i < postList.length; i++) {
          for (let j = 0; j < voteList.length; j++) {
            if (postList[i].postingId == voteList[j].postingId) {
              if (voteList[j].eStatus == "0") {
                postList[i].postingStatus = 0;
              }
              if (voteList[j].eStatus == "1") {
                postList[i].postingStatus = 1;
              }
            }
          }
        }
      });
      //查询用户是否对帖子进行收藏
      let collectionUrl =
        config.baseUrl +
        "collection/getCollectionByUserIdAndPostingIds/" +
        this.$store.state.user.id;
      this.$http.post(collectionUrl, this.postingIds).then(successData => {
        let data = successData.data;
        if (data.resCode == 0) {
          let collectionList = data.result;
          //存在数据，需要变色
          for (let i = 0; i < postList.length; i++) {
            for (let j = 0; j < collectionList.length; j++) {
              if (postList[i].postingId == collectionList[j].postingId) {
                postList[i].postingCollection = 0;
              }
            }
          }
        }
      });
    },
    // 路由到查看用户详情页面
    goUserData(username) {
      this.$router.push({
        name: "userData",
        params: {
          username: "@" + username
        }
      });
    },
    // 点赞帖子
    changesup(obj) {
      if (localStorage.getItem("token")) {
        let url = config.baseUrl + "posting/evaluationgood/" + obj.postingId;
        this.$http.get(url).then(function (successData) {
          let that = this;
          let data = successData.data;
          if (data.resCode == 0) {
            //在页面给点赞数加1
            obj.postingGoodnums = data.result;
            obj.postingStatus = 0;
          } else if (data.resCode == -11) {
            this.$Message.warning({
              content: this.$t("posting.evaluation"),
              duration: 2
            });
          } else if (data.resCode == -1) {
            this.$Message.warning({
              content: this.$t("posting.evaluation"),
              duration: 2
            });
          }
        });
      } else {
        this.$store.state.loginModal = true;
      }
    },
    // 踩帖子
    changesdown(obj) {
      if (localStorage.getItem("token")) {
        let url = config.baseUrl + "posting/evaluationstep/" + obj.postingId;
        this.$http.get(url).then(function (successData) {
          let that = this;
          let data = successData.data;
          if (data.resCode == 0) {
            //在页面给点踩数加1
            obj.postingStepnums = data.result;
            obj.postingStatus = 1;
          } else if (data.resCode == -1) {
            this.$Message.warning({
              content: this.$t("posting.evaluation"),
              duration: 1
            });
          } else if (data.resCode == -11) {
            this.$Message.warning({
              content: this.$t("posting.evaluation"),
              duration: 1
            });
          }
        });
      } else {
        this.$store.state.loginModal = true;
      }
    },
    // 转发
    postingforward() {
      let url = config.baseUrl + "posting/forward";
      this.$http.post(url, this.formValidatezf).then(
        successData => {
          let data = successData.data;
          this.forwardModal = false;
          if (data.resCode == 0) {
            this.$Message.success({
              content: this.$t("posting.forwardMessage"),
              duration: 2
            });
            for (var i = 0; i < this.posting.length; i++) {
              if (this.posting[i].postingId == this.formValidatezf.postingId) {
                this.posting[i].postingCountForword = data.result;
                break;
              }
            }
            this.formValidatezf.postingId = "";
            this.formValidatezf.postingForwardContext = "";
          } else if (data.resCode == -1) {
            this.$Message.error({
              content: this.$t("common.fail"),
              duration: 2
            });
          }
        },
        error => {
          this.forwardModal = false;
        }
      );
    },
    //点击转发弹出转发框
    modalzf(obj, user) {
      if (localStorage.getItem("token")) {
        this.formValidatezf.postingId = obj.postingId;
        this.formValidatezf.postingForwardContext = "";
        this.postUserImage = user.image; //头像
        this.postTitle = obj.postingTitle; //帖子标题
        this.postDate = obj.postingTime; //发帖日期
        this.postUserName = user.userName; //用户名
        this.postNickName = user.nickName; //昵称
        this.forwardModal = true;
      } else {
        this.$store.state.loginModal = true;
      }
    },
    //  关闭转发框
    postingforwardCancel() {
      this.forwardModal = false;
    },
    // 收藏帖子
    collectionPosting(posting) {
      if (!localStorage.getItem("token")) {
        this.$store.state.loginModal = true;
        return;
      }
      this.formCollection.userId = this.$store.state.user.id;
      this.formCollection.postingId = posting.postingId;
      this.$http
        .post(
          config.baseUrl + "collection/saveCollectionPosting",
          this.formCollection
        )
        .then(successData => {
          let data = successData.data;
          if (data.resCode == 0) {
            posting.postingCollection = 0;
          } else if (data.resCode == 1) {
            posting.postingCollection = -1;
          }
        });
    },
    //根据id跳转到帖子详情
    findsel(posting) {
      this.$router.push({
        name: "postingsel",
        params: {
          postingId: posting.postingId,
          username: posting.postingUserName
        }
      });
    },
    //查询所有标签
    getAllTagByHot() {
      this.$http
        .get(config.baseUrl + "tag/open/getTags/hot")
        .then(successData => {
          let data = successData.data.result;
          this.allTagList = data;
          if (data.length > 20) {
            for (let i = 0; i < 20; i++) {
              //向数组中添加元素
              this.tagList = this.tagList.concat(data[i]);
            }
            this.isShowAll = true;
          } else {
            this.tagList = data;
          }
        });
    },
    //显示所有
    showAllTag() {
      this.tagList = this.allTagList;
      this.isShowAll = false;
      this.isShowUpward = true;
    },
    //收起标签
    upwardTag() {
      this.tagList = [];
      for (let i = 0; i < 20; i++) {
        //向数组中添加元素
        this.tagList = this.tagList.concat(this.allTagList[i]);
      }
      this.isShowAll = true;
      this.isShowUpward = false;
    },
    //根据标签查找帖子
    getPostsByTagName(tagName) {
      if (tagName != null && tagName.trim() != "") {
        this.tagName = tagName;
      }
    },
    //格式化时间
    dateFormat(time) {
      let timeOffset = -28800000;
      if (this.user) {
        timeOffset = this.user.timeOffset;
      }
      return formatDate(time, timeOffset, this.$i18n.locale);
    }
  }
};
</script>



// WEBPACK FOOTER //
// MarketPosts.vue?0741b905